import { apiRequest, type QueryValue } from './client';
import type {
  AnalysesFilterOptions,
  AnalysisDetailView,
  AnalysisListFilters,
  AnalysisView,
  PageResponse,
} from './types';

export const analyses = {
  list: (organizationId: string, filters: AnalysisListFilters = {}) =>
    apiRequest<PageResponse<AnalysisView>>('/api/analyses', {
      organizationId,
      query: filters as Record<string, QueryValue>,
    }),

  filters: (organizationId: string) =>
    apiRequest<AnalysesFilterOptions>('/api/analyses/filters', { organizationId }),

  get: (organizationId: string, id: string) =>
    apiRequest<AnalysisDetailView>(`/api/analyses/${id}`, { organizationId }),

  retry: (organizationId: string, id: string) =>
    apiRequest<{ status: string; id: string }>(`/api/analyses/${id}/retry`, {
      method: 'POST',
      organizationId,
    }),

  remove: (organizationId: string, id: string) =>
    apiRequest<void>(`/api/analyses/${id}`, {
      method: 'DELETE',
      organizationId,
    }),

  setPrimaryJiraIssue: (organizationId: string, id: string, issueKey: string | null) =>
    apiRequest<AnalysisView>(`/api/analyses/${id}/primary-jira-issue`, {
      method: 'PATCH',
      organizationId,
      body: { issueKey },
    }),
};
